//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Icon",
  props: {
    name: {
      type: String,
      default: ""
    },
    iconClass: {
      type: String,
      default: ""
    },
    stack: {
      type: Boolean,
      default: false
    },
    stackIconName: {
      type: String,
      default: ""
    },
    stackIconClass: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    extraClasses() {
      if (this.spin) return "fa-spin";
      return "";
    }
  }
});